import { debounce } from './../utils/debounce';
class DetailsDisclosure extends HTMLElement {
    constructor() {
        super();
        this.mainDetailsToggle = this.querySelector('details');
        this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    }
    onFocusOut() {
        setTimeout(() => {
            if (!this.contains(document.activeElement))
                this.close();
        });
    }
    close() {
        this.mainDetailsToggle.removeAttribute('open');
    }
}
customElements.define('details-disclosure', DetailsDisclosure);
